import { HUES } from '../teams/premium';

// The six source groups (Nic 2026-10-25), one list for the whole Funnel: the
// Source menu, the Source performance table, the "Where they came from"
// chart and the Leads received tile all group, name and color sources the
// same way, so a bar always matches a table row. `key` is the server's
// trend key; `table` is the Source performance table's category key.
export const SOURCE_GROUPS = [
  { key: 'envoy', table: 'envoy', name: 'Envoy', color: HUES.indigo },
  { key: 'referralProgram', table: 'referral', name: 'Referral Program', color: HUES.violet },
  { key: 'partners', table: 'partners', name: 'Partners', color: HUES.emerald },
  { key: 'events', table: 'events', name: 'Events', color: HUES.orange },
  { key: 'website', table: 'website', name: 'Website', color: HUES.sky },
  { key: 'manual', table: 'manual', name: 'Manual / Other', color: HUES.slate },
];

export const colorOfTableCategory = (category) =>
  SOURCE_GROUPS.find((g) => g.table === category)?.color || HUES.slate;
